module.exports = __webpack_public_path__ + "img/banner.f2885a34.jpg";